import {FormControl, FormGroup} from '@angular/forms';
import {Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {merge} from 'rxjs/observable/merge';
import {of as observableOf} from 'rxjs/observable/of';
import {catchError} from 'rxjs/operators/catchError';
import {map} from 'rxjs/operators/map';
import {startWith} from 'rxjs/operators/startWith';
import {switchMap} from 'rxjs/operators/switchMap';
import {MatDialog} from '@angular/material';
import {ClientsDialogComponent} from '@app/app/clients/clients.dialog.component';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';
import {Subscription} from 'rxjs/Subscription';

@Component({
  moduleId: module.id,
  selector: 'clients',
  styleUrls: ['clients.css'],
  templateUrl: 'clients.component.html'
})

export class ClientsComponent implements OnInit, OnDestroy {
  displayedColumns = ['id', 'company_name', 'email', 'phone', 'created', 'actions'];
  dataSource = new MatTableDataSource();

  resultsLength = 0;
  isLoadingResults = true;

  filterForm = new FormGroup({
    query: new FormControl(),
    active: new FormControl(),
  });

  included = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  filter = new Filter();
  sub1: Subscription;
  sub2: Subscription;

  isAdmin = false;

  ngOnDestroy() {
    if (this.sub1) {
      this.sub1.unsubscribe();
    }

    if (this.sub2) {
      this.sub2.unsubscribe();
    }
  }

  constructor(private http: HttpClient, public dialog: MatDialog, private auth: AuthenticationService, private urlHelper: UrlHelper) {
    this.isAdmin = ('admin' === this.auth.userRole());
  }

  applyFilter(filterValue: string) {
    this.filter.change(filterValue);
  }

  private prepareUrl() {
    let sortField = '';

    if ((this.sort.direction === 'asc' || this.sort.direction === 'desc') && this.sort.active) {
      if (this.sort.direction === 'desc') {
        sortField = '-' + this.sort.active;
      } else if (this.sort.direction === 'asc') {
        sortField = this.sort.active;
      }
    }

    const page = this.paginator.pageIndex + 1 || 1;
    const query = this.filter.filterValue || '';
    const active = this.filter.activeValue || '';

    if (this.auth.userRole() === 'manufacturer') {
      return `/manufacturers/${this.auth.userId()}/clients?filter[query]=${query}&page=${page}&sort=${sortField}&filter[active]=${active}`;
    }

    return `/clients?filter[query]=${query}&page=${page}&sort=${sortField}&filter[active]=${active}`;
  }

  clear() {
    this.filter.reset();
    this.filterForm.patchValue({
      query: null,
      active: null
    });
  }

  toggleActive(value) {
    this.filter.changeA(value);
  }

  ngOnInit() {
    // If the user changes the sort order, reset back to the first page.
    this.sub1 = this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    this.sub2 = merge(this.filter.filterApplied, this.sort.sortChange, this.paginator.page).pipe(
      startWith({}),
      switchMap(() => {
        this.isLoadingResults = true;
        return this.http.get<any>(this.prepareUrl());
      }),
      map(data => {
        this.isLoadingResults = false;
        this.resultsLength = data.meta.pagination.total;
        return {data: data.data, included: data.included};
      }),
      catchError(() => {
        this.isLoadingResults = false;
        // Catch if the GitHub API has reached its rate limit. Return empty data.
        // this.isRateLimitReached = true;
        return observableOf({data: []});
      })
    ).subscribe((data: any) => {
      this.dataSource.data = data.data;
      this.included = data.included;
    });

    this.dataSource.sort = this.sort;
  }

  openDialog(user = null): void {
    const dialogRef = this.dialog.open(ClientsDialogComponent, {
      width: '400px',
      data: {user: user, included: this.included}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined' && result === 'Confirm') {
        this.reloadData();
      }
    });
  }

  deleteUserItem(user) {
    if (confirm(`Are you sure want to delete ${user.attributes.company_name}?`)) {
      this.http.delete(`/clients/${user.id}`).subscribe(res => {
        this.reloadData();
      });
    }
  }

  reloadData() {
    this.isLoadingResults = true;
    return this.http.get<any>(this.prepareUrl()).subscribe(data => {
      this.isLoadingResults = false;
      this.resultsLength = data.meta.pagination.total;
      this.dataSource.data = data.data;
      this.included = data.included;
    });
  }
}

export class Filter {
  filterApplied = new EventEmitter();
  filterValue = '';
  activeValue = '';

  reset() {
    this.filterValue = '';
    this.activeValue = '';
    this.filterApplied.emit();
  }

  change(val: string) {
    this.filterValue = val;
    this.filterApplied.emit();
  }

  changeA(val: string) {
    this.activeValue = val;
    this.filterApplied.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/clients/clients.component.ts